<template>
  <div class="panel-header panel-header-lg">
    <header-chart :height="255" :data="chartData" :labels="chartLabels">
    </header-chart>
  </div>
</template>

<script>
import HeaderChart from "./HeaderChart";

export default {
  name: "overview-header",
  components: {
    HeaderChart
  },
  data() {
    return {
      chartData: [50, 150, 100, 190, 130, 90, 150, 160, 120, 140, 190, 95],
      chartLabels: [
        "1월",
        "2월",
        "3월",
        "4월",
        "5월",
        "6월",
        "7월",
        "8월",
        "9월",
        "10월",
        "11월",
        "12월"
      ]
    };
  }
};
</script>

<style scoped></style>
